import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import RestauranteSelector from '../Components/CardRest/RestauranteSelector';
import CardapioPopup from '../Components/CardRest/CardapioPopup';
import ResumoPedido from '../Components/CardRest/ResumoPedido';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import AvaliacaoPopup from '../Components/CardRest/AvaliacaoPopup';
import { FaUtensils } from 'react-icons/fa';

const RestauranteFunc = () => {
    const [restaurantes, setRestaurantes] = useState([]);
    const [restauranteSelecionado, setRestauranteSelecionado] = useState(null);
    const [pedido, setPedido] = useState(null);
    const [statusBloqueio, setStatusBloqueio] = useState(false);
    const [mostrarAvaliacao, setMostrarAvaliacao] = useState(false);
    const [ultimadata, setUltimaData] = useState('');
    const [nomeRestaurante, setnomeRestaurante] = useState('');
    const [restav, setRestav] = useState(0);
    const [enviado, setEnviado] = useState(false);
    const chapa = localStorage.getItem("chapa");
    const navigate = useNavigate();
    
    useEffect(() => {
        const chapaStorage = localStorage.getItem("chapa");
        if (!chapaStorage) {
          navigate("/arbor/login");
        }
    }, [navigate]); 

    useEffect(() => {
        const fetchRestaurantes = async () => {
            if (!chapa) return;
            try {
                const res = await api.get(`/restaurante/${chapa}?codigo=0&loja=${localStorage.getItem("loja")}`);
                if (Array.isArray(res.data)) {
                    setRestaurantes(res.data);
                    const avaliacaoPendente = res.data.find(r =>
                        r.ultimaav && (r.ultimaav === "0" || r.ultimaav === 0)
                    );
                    if (avaliacaoPendente) {
                        setUltimaData(avaliacaoPendente.ultimadata || '');
                        setMostrarAvaliacao(true);
                        setnomeRestaurante(avaliacaoPendente.nomeultimorest || 'Restaurante');
                        setRestav(avaliacaoPendente.ultimorest);
                    } else {
                        const pedidoExistente = res.data.find(r => r.status !== null);
                        if (pedidoExistente) {
                            setPedido({
                                restaurante: pedidoExistente,
                                opcao: pedidoExistente.menu,
                                observacao: pedidoExistente.observacao,
                                hora: pedidoExistente.horasol,
                                turno: pedidoExistente.turno,
                                horaeft: pedidoExistente.status === 1 ? pedidoExistente.horaeft : null
                            });
                            setStatusBloqueio(true);
                            setRestauranteSelecionado(pedidoExistente);
                        }
                    }
                }
            } catch (err) {
                console.error('Erro ao carregar restaurantes:', err);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: 'Não foi possível carregar os dados do restaurante.',
                    confirmButtonColor: '#8b0000'
                });
            }
        };

        fetchRestaurantes();
    }, [chapa, mostrarAvaliacao, enviado]);

    const handleSelecionarRestaurante = (restaurante) => {
        if (!statusBloqueio) {
            setRestauranteSelecionado(restaurante);
        }
    };

    const handleConfirmarPedido = (dadosPedido) => {
        setPedido(dadosPedido);
        
        if (dadosPedido.restaurante.status === 0 || dadosPedido.restaurante.status === 1 || dadosPedido.status === 0) {
            setStatusBloqueio(true);
            setEnviado(true);
        }
    };

    const handleCancelarPedido = async () => {
        try {
            const res = await api.put(`/restaurante/${chapa}`, { acao: 'CANCELAR' });
            if (res.status === 200) {
                Swal.fire({
                    icon: 'info',
                    title: 'Cancelado',
                    text: 'Seu pedido foi cancelado com sucesso.',
                    confirmButtonColor: '#8b0000'
                });
                setEnviado(false);
            } else {
                const msg = res.data?.mensagem || 'Erro ao cancelar pedido';
                Swal.fire({
                    icon: 'error',
                    title: 'Erro',
                    text: msg,
                    confirmButtonColor: '#8b0000'
                });
            }
        } catch (err) {
            console.error('Erro ao cancelar pedido:', err);
            let msg = 'Falha na comunicação com o servidor';
            if (err.response?.data?.erro) {
                msg = Array.isArray(err.response.data.erro)
                    ? err.response.data.erro[0]
                    : err.response.data.erro;
            }
            Swal.fire({
                icon: 'error',
                title: 'Erro',
                text: msg,
                confirmButtonColor: '#8b0000'
            });
        } finally {
            setPedido(null);
            setStatusBloqueio(false);
            setRestauranteSelecionado(null);
        }
    };

    if (mostrarAvaliacao) {
        return (
            <AvaliacaoPopup
                usuario={chapa}
                datault={ultimadata}
                codigoRestaurante={restav}
                nomeRestaurante={nomeRestaurante}
                onClose={() => setMostrarAvaliacao(false)}
            />
        );
    }

    return (
        <div className="bg-light min-vh-100" style={{ paddingTop: '80px', paddingBottom: '40px' }}>
            <Menu modulo="ARBOR" />

            <div 
                className="container-fluid py-3 px-3 px-md-5"
                style={{ maxWidth: '1280px', margin: '0 auto' }}
            >
                {/* Título da Página */}
                <div className="d-flex align-items-center mb-4">
                    <FaUtensils className="me-2 text-danger fs-3" />
                    <div>
                        <h4 className="fw-bold m-0 text-dark">Refeição do Funcionário</h4>
                        <small className="text-muted">Selecione seu restaurante parceiro e monte seu pedido diário</small>
                    </div>
                </div>

                {!statusBloqueio && (
                    <RestauranteSelector
                        usuario={chapa}
                        onSelecionar={handleSelecionarRestaurante}
                        bloqueado={statusBloqueio}
                        restaurantes={restaurantes.filter(r => r.status === null)}
                    />
                )}

                {!statusBloqueio && restauranteSelecionado && (
                    <CardapioPopup
                        usuario={chapa}
                        restaurante={restauranteSelecionado}
                        onClose={() => setRestauranteSelecionado(null)}
                        onConfirm={handleConfirmarPedido}
                        onCancelar={handleCancelarPedido}
                    />
                )}

                {pedido && <ResumoPedido pedido={pedido} onCancelar={handleCancelarPedido} />}
            </div>

            <Footer />
        </div>
    );
};

export default RestauranteFunc;